import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, map, filter } from 'rxjs/operators';

import { DefaultConst } from '../constants';
import { Brand } from '../proto/brandassador/brands';
import { brand } from '../store/brands/brands.selectors';

@Injectable({
  providedIn: 'root',
})
export class RewardsGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.pipe(
      select(brand),
      take(1),
      map((brand: Brand) => {
        if (
          DefaultConst.REWARD_BRANDS.find(
            (brandName) => brandName === brand.displayName
          )
        ) {
          return true;
        }

        this.router.navigate(['/']);
        return false;
      })
    );
  }
}
